export class UnquotableZips {
  public static zips: Array<string> = ['77510', '77517', '77518', '77539', '77546', '77549', '77550', '77551', '77552', '77553', '77554', '77555', '77563', '77565', '77568', '77573', '77574', '77590', '77591', '77592', '77617', '77623', '77650'];
}
